import { createStyles, makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex'
    },
    formControl: {
      margin: theme.spacing(3)
    },
    formElement: {
      padding: '20px'
    },
    title: {
      textAlign: 'center'
    },
    flexContainer: {
      display: 'flex',
      flexDirection: 'row',
      padding: '20px',
      marginBottom: '20px'
    },
    filters: {
      display: 'flex',
      flex: 12,
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    actions: {
      display: 'flex',
      flex: 3,
      justifyContent: 'flex-end',
      alignContent: 'center'
    }
  })
)
